var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96049 11.9184C4.33855 5.88834 9.68923 1.46235 15.9116 2.03269L16.1969 2.05884C18.1503 2.23788 19.6343 3.97016 19.5116 5.92797C19.3888 7.88579 17.7058 9.32776 15.7524 9.14871L15.4671 9.12257C13.2852 8.92258 11.409 10.4745 11.2764 12.589L11.2741 12.6269C11.1471 14.6517 9.40649 16.143 7.38624 15.9578C5.366 15.7726 3.83117 13.9811 3.95812 11.9563L3.96049 11.9184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2813 3.07855C37.5036 3.64889 42.2414 8.99958 41.8633 15.0296L41.8609 15.0675C41.734 17.0923 39.9934 18.5836 37.9731 18.3985C35.9529 18.2133 34.418 16.4218 34.545 14.3969L34.5474 14.3591C34.6799 12.2446 33.0186 10.3684 30.8368 10.1684L30.5515 10.1423C28.5981 9.96323 27.1141 8.23096 27.2368 6.27314C27.3595 4.31533 29.0426 2.87335 30.996 3.0524L31.2813 3.07855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5865 30.629C40.2085 36.659 34.8578 41.085 28.6354 40.5147L28.3501 40.4885C26.3967 40.3095 24.9127 38.5772 25.0354 36.6194C25.1582 34.6616 26.8412 33.2196 28.7946 33.3986L29.0799 33.4248C31.2618 33.6248 33.138 32.0728 33.2705 29.9584L33.2729 29.9205C33.3999 27.8957 35.1405 26.4044 37.1608 26.5896C39.181 26.7747 40.7158 28.5663 40.5889 30.5911L40.5865 30.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2673 39.4687C7.04495 38.8984 2.30721 33.5477 2.68526 27.5176L2.68763 27.4797C2.81458 25.4549 4.55522 23.9636 6.57546 24.1488C8.59571 24.3339 10.1305 26.1255 10.0036 28.1503L10.0012 28.1882C9.86865 30.3026 11.5299 32.1788 13.7118 32.3788L13.9971 32.405C15.9505 32.584 17.4345 34.3163 17.3118 36.2741C17.189 38.2319 15.506 39.6739 13.5526 39.4948L13.2673 39.4687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.664062,
    y: 1.98322,
    width: 43.2204,
    height: 42.5809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.0b08ec17.svg";
export { ForwardRef as ReactComponent };